import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Base } from "./base";
import { generateColorRamp } from '@antv/l7-utils';
import { getLayerShape, getMaskValue } from "../utils";
import { TileStyleService } from "../style/TileStyleService";
import { TilePickService } from "../interaction/TilePickService";
import { TileRenderService } from "../render/TileRenderService";
import { styles, Attributes } from "../style/constants";
import { updateTexture, updateLayersConfig, setStyleAttributeField } from "../style/utils";
export var TileLayerManager = /*#__PURE__*/function (_Base) {
  _inherits(TileLayerManager, _Base);

  var _super = _createSuper(TileLayerManager);

  function TileLayerManager(parent, mapService, rendererService, pickingService, transforms) {
    var _this;

    _classCallCheck(this, TileLayerManager);

    _this = _super.call(this);
    _this.parent = parent;
    _this.children = parent.layerChildren;
    _this.mapService = mapService;
    _this.rendererService = rendererService;
    _this.transforms = transforms;
    _this.tileRenderService = new TileRenderService(rendererService);
    _this.tilePickService = new TilePickService(parent, rendererService, pickingService, _this.children, _this.tileRenderService);
    _this.tileStyleService = new TileStyleService();

    _this.setSubLayerInitOption();

    _this.setConfigListener();

    _this.initTileFactory();

    return _this;
  }

  _createClass(TileLayerManager, [{
    key: "render",
    value: function render() {
      this.tileStyleService.checkConfig(this.parent);
      this.tileRenderService.render(this.children);
    }
  }, {
    key: "pickLayers",
    value: function pickLayers(target) {
      return this.tilePickService.pick(this.children, target);
    }
  }, {
    key: "setSubLayerInitOption",
    value: function setSubLayerInitOption() {
      var _source$data;

      var _ref = this.parent.getLayerConfig(),
          _ref$zIndex = _ref.zIndex,
          zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex,
          _ref$opacity = _ref.opacity,
          opacity = _ref$opacity === void 0 ? 1 : _ref$opacity,
          _ref$mask = _ref.mask,
          mask = _ref$mask === void 0 ? false : _ref$mask,
          _ref$stroke = _ref.stroke,
          stroke = _ref$stroke === void 0 ? '#fff' : _ref$stroke,
          _ref$strokeWidth = _ref.strokeWidth,
          strokeWidth = _ref$strokeWidth === void 0 ? 0 : _ref$strokeWidth,
          _ref$strokeOpacity = _ref.strokeOpacity,
          strokeOpacity = _ref$strokeOpacity === void 0 ? 1 : _ref$strokeOpacity,
          _ref$clampLow = _ref.clampLow,
          clampLow = _ref$clampLow === void 0 ? true : _ref$clampLow,
          _ref$clampHigh = _ref.clampHigh,
          clampHigh = _ref$clampHigh === void 0 ? true : _ref$clampHigh,
          _ref$domain = _ref.domain,
          domain = _ref$domain === void 0 ? [0, 1] : _ref$domain,
          _ref$rampColors = _ref.rampColors,
          rampColors = _ref$rampColors === void 0 ? {
        colors: ['rgb(166,97,26)', 'rgb(223,194,125)', 'rgb(245,245,245)', 'rgb(128,205,193)', 'rgb(1,133,113)'],
        positions: [0, 0.25, 0.5, 0.75, 1.0]
      } : _ref$rampColors,
          _ref$featureId = _ref.featureId,
          featureId = _ref$featureId === void 0 ? 'id' : _ref$featureId,
          _ref$workerEnabled = _ref.workerEnabled,
          workerEnabled = _ref$workerEnabled === void 0 ? false : _ref$workerEnabled,
          sourceLayer = _ref.sourceLayer,
          _ref$pixelConstant = _ref.pixelConstant,
          pixelConstant = _ref$pixelConstant === void 0 ? 0 : _ref$pixelConstant,
          _ref$pixelConstantR = _ref.pixelConstantR,
          pixelConstantR = _ref$pixelConstantR === void 0 ? 256 * 256 : _ref$pixelConstantR,
          _ref$pixelConstantG = _ref.pixelConstantG,
          pixelConstantG = _ref$pixelConstantG === void 0 ? 256 : _ref$pixelConstantG,
          _ref$pixelConstantB = _ref.pixelConstantB,
          pixelConstantB = _ref$pixelConstantB === void 0 ? 1 : _ref$pixelConstantB,
          _ref$pixelConstantRGB = _ref.pixelConstantRGB,
          pixelConstantRGB = _ref$pixelConstantRGB === void 0 ? 0.1 : _ref$pixelConstantRGB;

      var colorValue = this.tileStyleService.getAttributeScale(this.parent, 'color');
      var sizeValue = this.tileStyleService.getAttributeScale(this.parent, 'size');
      var source = this.parent.getSource();

      var _ref2 = (source === null || source === void 0 ? void 0 : (_source$data = source.data) === null || _source$data === void 0 ? void 0 : _source$data.tilesetOptions) || {},
          coords = _ref2.coords;

      var parentParserType = source.getParserType();
      var layerShape = getLayerShape(this.parent.type, this.parent);
      this.initOptions = {
        layerType: this.parent.type,
        transforms: this.transforms,
        shape: layerShape,
        zIndex: zIndex,
        opacity: opacity,
        sourceLayer: this.getSourceLayer(parentParserType, sourceLayer),
        coords: coords,
        featureId: featureId,
        color: colorValue,
        size: sizeValue,
        mask: getMaskValue(this.parent.type, mask),
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeOpacity: strokeOpacity,
        // raster tiff
        clampLow: clampLow,
        clampHigh: clampHigh,
        domain: domain,
        rampColors: rampColors,
        // worker
        workerEnabled: workerEnabled,
        pixelConstant: pixelConstant,
        pixelConstantR: pixelConstantR,
        pixelConstantG: pixelConstantG,
        pixelConstantB: pixelConstantB,
        pixelConstantRGB: pixelConstantRGB
      };

      if (rampColors) {
        // 构建统一的色带贴图
        var createTexture2D = this.rendererService.createTexture2D;
        var imageData = generateColorRamp(rampColors);
        var colorTexture = createTexture2D({
          data: imageData.data,
          width: imageData.width,
          height: imageData.height,
          flipY: false
        });
        this.initOptions.colorTexture = colorTexture;
      }
    }
  }, {
    key: "getInitOptionValue",
    value: function getInitOptionValue(field) {
      var _this$parent$getAttri, _this$parent$getAttri2, _this$parent$getAttri3;

      switch (field) {
        case 'color':
          return (_this$parent$getAttri = this.parent.getAttribute('color')) === null || _this$parent$getAttri === void 0 ? void 0 : _this$parent$getAttri.scale;

        case 'shape':
          return (_this$parent$getAttri2 = this.parent.getAttribute('shape')) === null || _this$parent$getAttri2 === void 0 ? void 0 : _this$parent$getAttri2.scale;

        case 'size':
          return (_this$parent$getAttri3 = this.parent.getAttribute('size')) === null || _this$parent$getAttri3 === void 0 ? void 0 : _this$parent$getAttri3.scale;
        // @ts-ignore

        default:
          return this.initOptions[field];
      }
    }
  }, {
    key: "setInitOptionValue",
    value: function setInitOptionValue(field, value) {
      // @ts-ignore
      this.initOptions[field] = value;
    }
  }, {
    key: "setConfigListener",
    value: function setConfigListener() {
      var _this2 = this;

      var styleConfigs = styles[this.parent.type] || [];
      styleConfigs.map(function (style) {
        _this2.tileStyleService.setConfig(style, _this2.getInitOptionValue(style));
      });
      this.tileStyleService.on('updateConfig', function (updateConfigs) {
        updateConfigs.map(function (key) {
          return _this2.updateStyle(key);
        });
      });
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(style) {
      var _this3 = this;

      if (Attributes.includes(style)) {
        var _this$parent$getAttri4;

        var scaleValue = (_this$parent$getAttri4 = this.parent.getAttribute(style)) === null || _this$parent$getAttri4 === void 0 ? void 0 : _this$parent$getAttri4.scale;

        if (!scaleValue) {
          return;
        }

        this.children.map(function (child) {
          return setStyleAttributeField(child, _this3.parent, style, scaleValue);
        });
      }
    }
  }, {
    key: "updateStyle",
    value: function updateStyle(style) {
      var updateValue = null;

      if (Attributes.includes(style)) {
        this.updateAttribute(style);
      } else {
        var layerConfig = this.parent.getLayerConfig();

        if (!(style in layerConfig)) {
          return;
        } // @ts-ignore


        var config = layerConfig[style];
        updateValue = config;

        switch (style) {
          case 'rampColors':
            var texture = updateTexture(config, this.children, this.rendererService);
            this.initOptions.colorTexture = texture;
            break;

          default:
            updateLayersConfig(this.children, style, config);
        }
      }

      this.setInitOptionValue(style, updateValue);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.tilePickService.destroy();
    }
  }]);

  return TileLayerManager;
}(Base);